import $ from "jquery";

// describe and create object
class PopUp {
  constructor() {
    this.popup_navi = $(".header .infomaterial");
    this.close = $(".popup .close");
    this.gform_btn = $(".btn.gravity_form_btn");
    // Variablen, um die Scroll-Position zu speichern
    this.scrollPosition = { y: 0 };
    this.initialViewportHeight;
    this.intervalId;

    this.events();
  }

  // events for triggering function
  events() {
    this.popup_navi.on("click", (e) => this.addClassNav(e));
    this.close.on("click", (e) => this.removeClass(e));
    this.gform_btn.on("click", (e) => this.addClasstogformpopup(e));
    // Set an interval to log the scroll position every second (1000 milliseconds)
    // setInterval(this.logScrollPosition, 2000);
  }

  addClasstogformpopup(e) {
    e.preventDefault();
    // Scroll-Position speichern
    this.initialViewportHeight = window.innerHeight;
    this.scrollPosition.y = window.scrollY;
    console.log("Current viewport height:", this.initialViewportHeight);
    console.log("Scroll position saved:", this.scrollPosition.y);

    //When more then one Form Buttons are in the blocks of one page, open the right form for the right button
    var dataGform = $(e.currentTarget).data("gform");
    var popupSelector = ".popup.gform_" + dataGform;
    $(popupSelector).first().addClass("active");

    $("body").addClass("pop-active");
    $(window).scrollTop(0);
  }
  // method/function

  addClassNav(e) {
    e.preventDefault();
    // Scroll-Position speichern
    this.initialViewportHeight = window.innerHeight;
    this.scrollPosition.y = window.scrollY;
    console.log("Current viewport height:", this.initialViewportHeight);
    console.log("Scroll position saved:", this.scrollPosition.y);

    $(".footer .popup.for_navi").addClass("active");
    $("body").addClass("pop-active");

    $(window).scrollTop(0);
  }

  scrolltoPosition(e) {
    let currentViewportHeight = window.innerHeight;
    console.log("Current scroll position:", window.scrollY);
    console.log("Current viewport height:", currentViewportHeight);

    // Check if the viewport height is the same as the initial height
    if (currentViewportHeight === this.initialViewportHeight) {
      // Scroll down to the target position if the heights match
      window.scrollTo(0, this.scrollPosition.y);
      console.log(this.scrollPosition.y);

      // Stop checking after scrolling to target
      clearInterval(this.intervalId);
    }
  }

  removeClass() {
    $(".popup").removeClass("active");
    $("body").removeClass("pop-active");
    this.intervalId = setInterval((e) => this.scrolltoPosition(e), 50);
    // setTimeout(() => {
    //   console.log("Delayed for 1 second.");
    //   $(window).scrollTop(this.scrollPosition.y);
    // }, 1000);
  }

  logScrollPosition() {
    console.log("Current scroll position:", window.scrollY);
  }
}

export default PopUp;
